import { useSelector } from "react-redux";

import { InventorySparesFilterPage } from "../inventorySparesFilterPage/InventorySparesFilterPage";
import { InventorySparesTablePage } from "../inventorySparesTable/InventorySparesTablePage";
import { CategoryPageSkeleton } from "../../../../component/skeleton/CategoryPageSkeleton";

import { selectInventorySpareFilterState } from "../../../../store/inventory/inventorySparesSlice";

import {
  selectInventorySpares,
  useGetInventorySparesListQuery,
} from "../../../../services/inventory/spares/inventorySpareApiSlice";
import classes from "./inventorySparesListingPage.module.css";

export const InventorySparesListingPage = () => {
  return (
    <div className={classes.box}>
      <InventorySparesFilterPage />
      <InventorySparesTablePage />
    </div>
  );
};
